import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { PermissionsContext, } from "src/App/components/GetPermissions";
import useDefinitions from "src/queries/useDefinitions";
const Subnav = () => {
    const permissions = useContext(PermissionsContext);
    console.log(permissions);
    const { isLoading } = useDefinitions();
    console.log("Is definitions got loaded:", !isLoading);
    return (React.createElement("nav", { className: "center" },
        React.createElement("ol", { className: "center" },
            React.createElement("li", null,
                React.createElement(Link, { to: "/" }, "Home")),
            React.createElement("li", null,
                React.createElement(Link, { to: "/add" }, "Add")),
            permissions?.hasAdminAccess && (React.createElement("li", null,
                React.createElement(Link, { to: "/upload" }, "Upload"))),
            React.createElement("li", null,
                React.createElement(Link, { to: "/help" }, "Help")))));
};
export default Subnav;
